import { Container } from "react-bootstrap"

const AdminHome = () => {

    return (
        <Container>
            <h1 className="text-center">Admin</h1>
            <p>admin home ...</p>
            
        </Container>
    );
}

export default AdminHome;